import { Checkbox } from "@/react/components/shared/uikit/Form/Checkbox";

export const CheckboxColumnHeader = ({
  allOnPageSelected,
  handleSelectAllOnPage,
}: {
  allOnPageSelected: boolean;
  handleSelectAllOnPage: (checked: boolean) => void;
}) => (
  <Checkbox
    checked={allOnPageSelected}
    onChange={e => handleSelectAllOnPage(e.target.checked)}
    name="select-all"
    isFormItem={false}
  />
);
